module.exports = __webpack_public_path__ + "img/icons8-idea-100.c49a0a6a.svg";